import { css } from 'emotion';

import { colors } from '../styles';

const container = css`
  position: relative;
`;

/*
 * The use of transform scale instead of defining directly the handle's width and height
 * is necessary due to these properties were causing a click issue in the handles. If the
 * step size is smaller than the handle size, it'll end up clicking on a different step.
 */
const sliderStyle = css`
  .rc-slider-rail {
    background-color: ${colors.gray.light};
    height: 3px;
  }
  .rc-slider-track {
    background-color: ${colors.primary.default};
    height: 3px;
  }
  .rc-slider-handle {
    border: 1px solid ${colors.gray.light};
    transform: scale(1.33);
    box-shadow: 2px 2px 10px 0 ${colors.custom.gray20};

    &:hover {
      border-color: ${colors.gray.light};
      box-shadow: none;
    }
  }
  &.rc-slider-disabled {
    background-color: transparent;

    & + div .rc-slider-tooltip-inner {
      background-color: ${colors.gray.default};
    }
  }
`;

const tipStyle = css`
  margin-top: 6px;
  box-shadow: none;
  pointer-events: none;

  .rc-slider-tooltip-inner {
    background-color: ${colors.primary.default};
    border-radius: 3px;
    padding: 2px 5px;
    line-height: 18px;
    max-height: 21px;
  }
`;

export { container, sliderStyle, tipStyle };
